import styled from 'styled-components';

export const TextDescriptionWrapper = styled.div`
  width: 100%;

  fieldset {
    height: 100%;
  }
`;
